import { createContext } from 'react'
import { SignupContextType } from '../types'

export const SignupContext = createContext<SignupContextType>(null)
